import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Error as ErrorIcon } from '@icons/dialer/calls';

interface IErrorState {
  className?: string;
  error: string;
}

const ErrorState = ({ className, error }: IErrorState) => (
  <StyledErrorState className={className}>
    <StyledContent>
      <ErrorIcon width={27} />
      <StyledInfo>
        <span>{error}</span>
      </StyledInfo>
    </StyledContent>
  </StyledErrorState>
);

const StyledErrorState = styled.form`
  background-image: linear-gradient(to left, #e50e5c, #ec8926);
  width: 100%;
  height: 65px;
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
`;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const StyledInfo = styled.div`
  color: #fff;
  margin-left: 15px;

  span {
    font-size: 17px;
  }
`;

export default ErrorState;
